import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import merge from "lodash.merge";
import { GlobalStyles as TSSGlobalStyles } from "tss-react";
import { useTheme } from "./theme-provider.js";
const createGlobalStyles = (theme, overrides) => merge({
    "*, *::before, *::after": {
        boxSizing: "border-box",
    },
    "html": {
        fontSize: theme.typography.baseFontSize,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
    },
    "body": Object.assign(Object.assign({ margin: 0 }, theme.typography.body), { color: theme.colors.text, backgroundColor: theme.colors.background }),
    "h1": theme.typography.h1,
    "h2": theme.typography.h2,
    "h3": theme.typography.h3,
    "h4": theme.typography.h4,
    "h5": theme.typography.h5,
    "h6": theme.typography.h6,
    "small": theme.typography.small,
    "label": theme.typography.label,
    "code": theme.typography.code,
}, overrides);
const defaultOverrides = () => ({});
export function GlobalStyles({ overrides = defaultOverrides }) {
    const { theme } = useTheme();
    const styles = useMemo(() => createGlobalStyles(theme, overrides(theme)), [overrides, theme]);
    return _jsx(TSSGlobalStyles, { styles: styles });
}
export default GlobalStyles;
//# sourceMappingURL=global-styles.js.map